import { fork } from "redux-saga/effects";
import bookingsSagaCreateBooking from "./saga.createBooking";
import bookingsSagaGetBooking from "./saga.getBookings";
import bookingsSagaSearchBooking from "./saga.searchBooking";
import bookingsSagaSelectBooking from "./saga.selectBooking";
import bookingsSagaUpdateBooking from "./saga.updateBooking";

const bookingSaga = [
  fork(bookingsSagaGetBooking),
  fork(bookingsSagaCreateBooking),
  fork(bookingsSagaSelectBooking),
  fork(bookingsSagaUpdateBooking),
  fork(bookingsSagaSearchBooking),
];

export default bookingSaga;